import { useEffect, useState } from 'react';

const STORAGE_KEY = 'main_sidebar_open';

const _isMobile = typeof window !== 'undefined' && window.innerWidth <= 1024;

let _isOpen: boolean;
try {
  _isOpen = _isMobile ? false : localStorage.getItem(STORAGE_KEY) !== 'false';
} catch {
  _isOpen = !_isMobile;
}

const _listeners = new Set<() => void>();
const notifyAll = () => _listeners.forEach(fn => fn());

export const sidebarStore = {
  get isOpen() { return _isOpen; },
  toggle() {
    _isOpen = !_isOpen;
    try { localStorage.setItem(STORAGE_KEY, String(_isOpen)); } catch { /* ignore */ }
    notifyAll();
  },
};

export const useSidebar = () => {
  const [, rerender] = useState(0);

  useEffect(() => {
    const handler = () => rerender(n => n + 1);
    _listeners.add(handler);
    return () => { _listeners.delete(handler); };
  }, []);

  return { isOpen: _isOpen, toggle: sidebarStore.toggle };
};
